"use client";
import HeroSection from "./components/heroSections";
import { GNS3_HOSTED_BACKED_SERVICES_LIST } from "./components/constants";
import { SectionDivider } from "app/components/shared/SectionDivider";
import ListLayout from "app/components/shared/listLayout";
import Certificates from "app/components/views/home/Certificates";
import Gns3Pricing from "./components/gns3Pricing";
import GNS3PricingTypes from "./components/pricingTypes";
import CustomCarousel from "app/components/shared/CustomCarousel";
import TalkToUs from "app/components/shared/talkToUs";
import WhyGNS3 from "./components/whyGNS3";
import { FAQ_List } from "./components/faqConstants";
import CustomAccordionList from "./components/customaccordion";

const Gns3Page = () => {
  return (
    <>
      <HeroSection />
      <WhyGNS3 />
      <SectionDivider label="OUR HOSTED SERVICES ARE BACKED BY" />
      <ListLayout data={GNS3_HOSTED_BACKED_SERVICES_LIST} />
      <Certificates />
      <GNS3PricingTypes />
      <Gns3Pricing />
      <CustomAccordionList items={FAQ_List} />
      <CustomCarousel />
      <TalkToUs />
    </>
  );
};

export default Gns3Page;
